export default __webpack_public_path__ + "static/media/artistAuthArt.8a46de6b.gif";